import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=b4056d7a&"
import script from "./ButtonEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports